import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const rootElement = document.getElementById("root");

// react-snap prerenders <title>/description/canonical/og/twitter tags
// per route, but react-helmet-async only manages tags carrying its own
// data-rh marker — it won't recognize these on mount, so it appends a
// duplicate instead of replacing them. Strip the prerendered ones here,
// before Helmet takes over, so only Helmet's copy ever exists.
document.head
  .querySelectorAll(
    [
      "title",
      'meta[name="description"]',
      'link[rel="canonical"]',
      'meta[property="og:title"]',
      'meta[property="og:description"]',
      'meta[property="og:url"]',
      'meta[name="twitter:title"]',
      'meta[name="twitter:description"]',
    ].join(",")
  )
  .forEach((el) => {
    if (!el.hasAttribute("data-rh")) el.remove();
  });

// ✅ JSX (NOT render function)
const app = (
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>
);

// ✅ Render logic
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}